<template>
  <div class="leaderboard-actions">
    <span v-if="finalSlide && showCarousel && !showWinner">
      <span class="mr-1">{{ $t('Show Winner') }}</span>
      <aha-shortcut-key keyName="W" class="inline" />
      <span v-if="isTeamPlay" class="separator mx-4"></span>
    </span>
    <span v-if="isTeamPlay">
      <span class="mr-1" v-if="isShowingIndividualLeaderboardForTeamPlay">{{ $t('Show Team Ranking') }}</span>
      <span class="mr-1" v-else>{{ $t('Show Individual Ranking') }}</span>
      <aha-shortcut-key keyName="I" class="inline" />
    </span>
  </div>
</template>
<script>

export default {
  props: {
    finalSlide: {
      type: Boolean,
      default: false,
    },
    showCarousel: {
      type: Boolean,
      default: false,
    },
    showWinner: {
      type: Boolean,
      default: false,
    },
    isShowingIndividualLeaderboardForTeamPlay: {
      type: Boolean,
      default: false,
    },
    isTeamPlay: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.leaderboard-actions {
  position: absolute;
  font-size: 1rem;
  bottom: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  .separator {
    border-left: 1px solid rgba(175, 175, 175, 1);
  }
}
</style>
